"use client"

import { usePathname } from "next/navigation"
import type { AnchorHTMLAttributes, CSSProperties } from "react"

type AProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  disabled?: boolean
}

export default function A({ children, disabled, href, rel, style, tabIndex, target, ...props }: AProps) {
  const pathname = usePathname() || "/"

  let resolvedHref = href

  if (typeof href === "string" && href.startsWith("#")) {
    resolvedHref = `${pathname.split("#")[0]}${href}`
  }

  const isAbsolute = typeof resolvedHref === "string" && resolvedHref.startsWith("http")
  const resolvedTarget = target || (isAbsolute ? "_blank" : undefined)
  const resolvedRel = rel || (isAbsolute ? "noopener noreferrer" : undefined)
  const resolvedStyle: CSSProperties | undefined = disabled
    ? {
        ...style,
        pointerEvents: "none",
      }
    : style

  return (
    <a
      {...props}
      href={resolvedHref}
      rel={resolvedRel}
      style={resolvedStyle}
      tabIndex={disabled ? -1 : tabIndex}
      target={resolvedTarget}
    >
      {children}
    </a>
  )
}
